import { render, staticRenderFns } from "./KvButtonIcon.vue?vue&type=template&id=6aecb4d7&"
import script from "./KvButtonIcon.vue?vue&type=script&lang=ts&"
export * from "./KvButtonIcon.vue?vue&type=script&lang=ts&"
import style0 from "./KvButtonIcon.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports